var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8379V8.1621C0 7.6674 0.362371 7.24774 0.850654 7.16831C7.64918 6.06232 13.2717 4.15134 18.42 1.01199C19.1032 0.595348 20 1.0761 20 1.87638V18.1236C20 18.9239 19.1032 19.4047 18.42 18.988C13.2716 15.8487 7.64918 13.9377 0.850654 12.8317C0.362371 12.7523 0 12.3326 0 11.8379Z",
    fill: "currentColor",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18.7352C16.7014 17.964 15.3718 17.2695 14 16.6448V3.355C15.3718 2.73039 16.7014 2.03584 18 1.26465V18.7352Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36996 13.5005L4.20255 14.2256C3.82984 15.84 4.83642 17.4508 6.45081 17.8235L7.42518 18.0485C9.03957 18.4212 10.6504 17.4146 11.0231 15.8002L11.1035 15.4522C10.4795 15.2212 9.84618 15.0024 9.2025 14.7955L9.07441 15.3503C8.95017 15.8885 8.41321 16.224 7.87508 16.0998L6.90071 15.8748C6.36258 15.7506 6.02706 15.2136 6.15129 14.6755L6.31571 13.9633C5.67777 13.7994 5.02944 13.6453 4.36996 13.5005Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.a9186723f19e8d310f9331d2eff424b2.svg";
export { ForwardRef as ReactComponent };